var map = {
	"./arr-l.svg": "./src/icons/arr-l.svg",
	"./arr-r.svg": "./src/icons/arr-r.svg",
	"./arr2.svg": "./src/icons/arr2.svg",
	"./burger.svg": "./src/icons/burger.svg",
	"./check.svg": "./src/icons/check.svg",
	"./close.svg": "./src/icons/close.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons sync \\.svg$";